<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch06"></a><a id="page_6"></a><a href="#/contents#ch06"><b>The Blues</b></a></h2>
<p class="noindent"><span>The term “feeling blue” has its roots in nautical traditions. In the old days, when a captain or officer died, the ship flew a blue flag.</span></p>
<p class="noindent"><span>People sitting in the first few rows of a Blue Man Group concert get plastic ponchos before the show to protect them from the mess created as the performers bang on the liquid-filled tops of drums.</span></p>
<p class="noindent"><span>In many languages, people use the same word for the colors blue and green.</span></p>
<p class="noindent"><span>The sky is blue because of the way the human eye perceives color. On sunny days, light scatters in such a way that the eye “sees” only the blue part of the spectrum.</span></p>
<p class="noindent"><span>First official blues record: Hart A. Wand’s “Dallas Blues,” in 1912.</span></p>
<p class="noindent"><span>In 2002’s <i>Die Another Day</i>, James Bond sliced Thomas Gainsborough’s painting “The Blue Boy” with a sword.</span></p>
<p class="noindent"><span>The Toronto Blue Jays are the only Major League Baseball team located outside the United States.</span></p>
<p class="noindent"><span>World’s largest blue sapphire: the Blue Giant of the Orient, at 466 carats.</span></p>
<p class="noindent"><span>Canada’s largest fruit crop: blueberries.</span></p>
<p class="noindent"><span>The term “blue jeans” comes from the French <i>bleu de Gênes</i>, meaning “blue of Genoa.” Why? Some of the first denim pants were manufactured in Italy and were shipped out of the port of Genoa.</span></p>
<p class="noindent"><span>Bluebirds were considered a rare species until 1996.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter06.vue?4aa91522